// Copia texto para a area de transferencia com fallback para contextos
// nao-seguros (HTTP). navigator.clipboard so existe em HTTPS/localhost,
// entao usamos o metodo legado execCommand quando ele nao esta disponivel.
export async function copyToClipboard(text) {
  // Caminho moderno (HTTPS / localhost)
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      // cai para o fallback abaixo
    }
  }
  // Fallback legado: funciona em HTTP via textarea + execCommand
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.setAttribute("readonly", "");
    ta.style.position = "fixed";
    ta.style.top = "-9999px";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, text.length);
    const ok = document.execCommand("copy");
    document.body.removeChild(ta);
    return ok;
  } catch {
    return false;
  }
}
